var _circle, _circle2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIconDefaultAvatar = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 32,
  height: 32,
  viewBox: "0 0 32 32",
  fill: "none"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 16,
  cy: 16,
  r: 15.5,
  fill: "#EDEDED",
  stroke: "#E9EAEB"
})), /*#__PURE__*/React.createElement("mask", {
  id: "mask0_323_2607",
  style: {
    maskType: "alpha"
  },
  maskUnits: "userSpaceOnUse",
  x: 0,
  y: 0,
  width: 32,
  height: 32
}, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 16,
  cy: 16,
  r: 15.5,
  fill: "white",
  stroke: "white"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0_323_2607)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 15.9996,
  cy: 14.8839,
  r: 5.2093,
  fill: "#C8C8C8"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.9996 22.0774C11.0698 22.0829 7.07485 26.0779 7.06937 31.0076C7.06937 31.5556 7.5136 31.9999 8.0616 31.9999H23.9376C24.4856 31.9999 24.9298 31.5556 24.9298 31.0076C24.9243 26.0779 20.9294 22.0828 15.9996 22.0774Z",
  fill: "#C8C8C8"
}))));
export default __webpack_public_path__ + "static/media/icon_default_avatar.eafe1288.svg";
export { SvgIconDefaultAvatar as ReactComponent };